module.exports = __webpack_public_path__ + "img/6e741e1.jpg";